// @ts-check
import { createContext, useContext } from "react";

/**
 * @type {React.Context<{
 *   chatId: string,
 *   dashboardId: string,
 *   store: any,
 *   storeRetriever: (channel: string) => any,
 * }>}
 */

export const AIDashboardContext = createContext({
  chatId: null,
  dashboardId: null,
  store: null,
  storeRetriever: () => null,
});

export const useAIDashboard = () => {
  return useContext(AIDashboardContext);
};

export const makeChannelName = (chatId, dashboardId, channel) => {
  return `${chatId}_${dashboardId}_${channel}`.replace(/ /g, "-");
};

export const useAIDashboardStore = (channel) => {
  const { storeRetriever } = useContext(AIDashboardContext);

  return storeRetriever(channel);
};
